import React from 'react';
import { Helmet } from 'react-helmet'

const BrowserTitleBar = ({title = "Mopit - Servicios a Domicilio"}) => {
  return (
    <Helmet>
        <title>{ title }</title>
    </Helmet>
  );
};

export default BrowserTitleBar;
